module.exports = __webpack_public_path__ + "static/media/pencil.2d216e0b.svg";